import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ComparePlusIcon from '../../assets/icons/complarePlus'
import { updateComparableSecurities } from '../../reducer/chart.reducer'
import { ExpressionCallbackData } from './typings'
import { selectChartComparableSecurities } from '../../selectors/chart'
import { Security } from '../../proto/generated/security'
import { ExtraSmallButton } from '../custom'
import SecuritySearchModal from './SecuritySearchModal'
import { getSecuritiesFromSecuritiesObj } from '../../util/security'
import { Tooltip } from '@mui/material'

interface Props {
    viewKey: string
    disabled: boolean
}

const SecurityCompare = (props: Props) => {
    const { viewKey, disabled } = props
    const dispatch = useDispatch()
    const currentComparableSecurities: Security[] = useSelector(selectChartComparableSecurities(viewKey))
    const [securitiesModalOpen, setSecuritiesModalOpen] = useState<boolean>(false)

    const onSecuritySelected = async (data: ExpressionCallbackData) => {
        const securities = await getSecuritiesFromSecuritiesObj(data.securities)
        if (!securities) return
        const [security] = securities
        const comparableSecurities = [...currentComparableSecurities]
        const index = currentComparableSecurities.findIndex((sec) => (sec.code === security.code && sec.exchange === security.exchange))

        if (index === -1) {
            comparableSecurities.push(security)
        }

        dispatch(updateComparableSecurities({
            viewKey,
            comparableSecurities
        }))
    }

    return (
        <div>
            <Tooltip title={
                <span
                    style={{ fontSize: '12px' }}>Compare or Add Security</span>}
                arrow placement="bottom">
                <span>
                <ExtraSmallButton
                    size="small"
                    color="inherit"
                    onClick={() => {
                        setSecuritiesModalOpen(true)
                    }}
                    disabled={disabled}
                    data-event={'Compare Security Opened'}
                    data-event-source={'stockbar'}
                >
                    <ComparePlusIcon />
                </ExtraSmallButton>
                </span>
            </Tooltip>
            {
                securitiesModalOpen && <SecuritySearchModal
                    open={securitiesModalOpen}
                    enableExpressions={false}
                    onCloseClicked={() => {
                        setSecuritiesModalOpen(false)
                    }}
                    onSecuritySelected={onSecuritySelected}
                />
            }
        </div>
    )
}
export default React.memo(SecurityCompare)
